module.exports = __webpack_public_path__ + "static/media/a1.abc2714.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sijie/a1.mp3
// module id = obHF
// module chunks = 0